var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('videoAds.pageTitle'),"description":_vm.$t('videoAds.pageSubtitle'),"to":{ name: _vm.RouteName.Interactive }}},[_c('VideoAds')],1)}
var staticRenderFns = []

export { render, staticRenderFns }